module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "squares",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('ul', {
    staticClass: "list_pic clearfix"
  }, _vm._l((_vm.data), function(item) {
    return _c('li', {
      directives: [{
        name: "handle-hover",
        rawName: "v-handle-hover"
      }],
      key: item.goods_id,
      staticClass: "item"
    }, [_c('div', {
      staticClass: "goods-content"
    }, [_c('div', {
      staticClass: "goods-pic"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: item.goods_id
          }
        },
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": item.thumbnail,
        "alt": _vm.htmlFiler(item.name)
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "goods-info"
    }, [_c('div', {
      staticClass: "goods-pic-scroll-show"
    }, [_c('div', {
      staticClass: "ul"
    }, [_c('img', {
      staticStyle: {
        "vertical-align": "middle"
      },
      attrs: {
        "src": item.thumbnail,
        "height": "28",
        "width": "28",
        "border": "0"
      }
    }), _vm._v(" "), (item.store_id == 1 && parseInt(item.source_flag) != 2) ? _c('img', {
      staticStyle: {
        "width": "44px",
        "height": "16px",
        "border": "0",
        "vertical-align": "middle",
        "margin-right": "3px"
      },
      attrs: {
        "src": "//static.kxymall.com/images/gdzy.png",
        "width": "44",
        "height": "16",
        "title": "开心自营，品质保障"
      }
    }) : _vm._e(), _vm._v(" "), (item.store_id == 1 && parseInt(item.source_flag) == 2) ? _c('img', {
      staticStyle: {
        "width": "44px",
        "height": "16px",
        "border": "0",
        "vertical-align": "middle",
        "margin-right": "3px"
      },
      attrs: {
        "src": "//images.kxymall.com/gdzg.png",
        "width": "44",
        "height": "16",
        "title": "开心自营，品质保障"
      }
    }) : _vm._e(), _vm._v(" "), (item.goods_transfee_charge == 1) ? _c('label', {
      staticStyle: {
        "background-color": "red",
        "color": "white",
        "vertical-align": "middle"
      }
    }, [_vm._v("包邮")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "goods-name"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: item.goods_id
          }
        },
        "target": "_blank"
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    })])], 1), _vm._v(" "), (_vm.goodsType === 'batch') ? _c('div', {
      staticClass: "goods-price"
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v("批发价：")]), _vm._v(" "), _c('em', {
      staticClass: "sale-price",
      attrs: {
        "title": '原价：¥' + item.mktprice
      }
    }, [_vm._v("¥" + _vm._s(item.price))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "left",
        "margin-left": "20px"
      }
    }, [_vm._v("会员价：")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "text-decoration": "line-through"
      }
    }, [_vm._v("¥" + _vm._s(item.batch_price))])]) : _vm._e(), _vm._v(" "), (_vm.getGoodsType === 'chain') ? _c('div', {
      staticClass: "goods-price"
    }, [_c('em', {
      staticClass: "sale-price",
      attrs: {
        "title": '原价：¥' + item.mktprice
      }
    }, [_vm._v("¥" + _vm._s(item.price))]), _vm._v(" "), (parseInt(item.source_flag) === 2 && item.coupon_amount_by_chain > 0) ? _c('span', {
      staticStyle: {
        "float": "left",
        "margin-left": "20px"
      }
    }, [_vm._v("现金券抵扣：")]) : _vm._e(), _vm._v(" "), (parseInt(item.source_flag) === 2 && item.coupon_amount_by_chain > 0) ? _c('span', [_vm._v("¥" + _vm._s(item.coupon_amount_by_chain))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.goodsType != 'batch' && _vm.getGoodsType != 'chain') ? _c('div', {
      staticClass: "goods-price"
    }, [_c('em', {
      staticClass: "sale-price",
      attrs: {
        "title": '原价：¥' + item.mktprice
      }
    }, [_vm._v("¥" + _vm._s(item.price))]), _vm._v(" "), (parseInt(item.vouchers_status) === 2) ? _c('span', {
      staticStyle: {
        "float": "left",
        "margin-left": "20px"
      }
    }, [_vm._v("现金券抵扣：")]) : _vm._e(), _vm._v(" "), (parseInt(item.vouchers_status) === 2) ? _c('span', [_vm._v("¥" + _vm._s(item.vouchers_coupon_amout))]) : _vm._e(), _vm._v(" "), (parseInt(item.source_flag) === 4 && item.subsidyPoint > 0) ? _c('span', {
      staticStyle: {
        "float": "left",
        "margin-left": "20px"
      }
    }, [_vm._v("补助积分：")]) : _vm._e(), _vm._v(" "), (parseInt(item.source_flag) === 4 && item.subsidyPoint > 0) ? _c('span', [_vm._v(_vm._s(item.subsidyPoint))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "sell-stat"
    }, [_c('ul', [_c('li', [_c('a', {
      staticClass: "status",
      attrs: {
        "href": "javascript:void(0)",
        "onclick": "return false;"
      }
    }, [_vm._v(_vm._s(item.buy_num))]), _vm._v(" "), _c('p', [_vm._v("商品销量")])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": "javascript:void(0)",
        "onclick": "return false;"
      }
    }, [_vm._v(_vm._s(item.comment_num))]), _vm._v(" "), _c('p', [_vm._v("用户评论")])])])]), _vm._v(" "), _c('div', {
      staticClass: "store"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/shop',
          query: {
            store_id: item.store_id,
            tab: 1
          }
        },
        "target": "_blank"
      }
    }, [_vm._v("\n              店铺：" + _vm._s(item.store_name) + "\n            ")])], 1), _vm._v(" "), (_vm.goodsType === 'batch') ? _c('div', {
      staticClass: "add-cart"
    }, [_c('span', [_vm._v("起批量：" + _vm._s(item.batch_amount))]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: item.ori_goods_id
          }
        },
        "target": "_blank"
      }
    }, [_vm._v("点击查看原商品\n            ")])], 1) : _c('div', {
      staticClass: "add-cart"
    }, [_c('a', {
      staticClass: "add_cart",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.cAddCart(item)
        }
      }
    }, [_vm._v("\n              加入购物车\n            ")]), _vm._v(" "), _c('a', {
      staticClass: "buynow",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.buynow(item)
        }
      }
    }, [_vm._v("\n              立即购买\n            ")])])])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2010504b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/goods-godule/module-right-goods.vue
// module id = 1547
// module chunks = 1